<template>
  <div class="main">
    <div class="header">
      <img :src="topImg" alt="" />
      <!-- <p>第一届国家传染病医学中心</p> -->
      <!-- <p>合作论坛</p> -->
    </div>
    <!-- <p class="tip">*为了方便您线下参会，请您填写以下信息，提交一次即可；</p>
    <p class="tip" style="margin-top: 5px">
      *本次会议免注册费，欲参会的代表请提前注册， 住宿、交通费用自理。
    </p>
    <div class="form">
      <div class="title">基础信息</div>

      <van-field
        v-model="form.name"
        required
        name="姓名"
        label="姓名"
        placeholder="请输入姓名"
        :rules="[{ required: true, message: '请填写用户名' }]"
      />
      <van-field
        name="radio"
        label="性别"
        required
        :rules="[{ required: true, message: '请选择性别' }]"
      >
        <template #input>
          <van-radio-group v-model="form.gender" direction="horizontal">
            <van-radio :name="0">男</van-radio>
            <van-radio :name="1">女</van-radio>
          </van-radio-group>
        </template>
      </van-field>
      <van-field
        v-model="form.phoneNumber"
        name="联系电话"
        required
        label="联系电话"
        placeholder="请输入联系电话"
        :rules="[{ required: true, message: '请填写联系电话' }]"
      />
      <van-field
        v-model="form.identityCard"
        name="身份证"
        required
        label="身份证"
        placeholder="请输入身份证"
        :rules="[{ required: true, message: '请填写身份证' }]"
      />
      <van-field
        v-model="form.enterprise"
        name="单位"
        required
        label="单位"
        placeholder="请输入单位"
        :rules="[{ required: true, message: '请填写单位' }]"
      />
      <van-field
        v-model="form.job"
        name="职务"
        required
        label="职务"
        placeholder="请输入职务"
        :rules="[{ required: true, message: '请填写职务' }]"
      />
      <van-field
        readonly
        clickable
        v-model="form.source"
        name="来源地"
        required
        label="来源地"
        placeholder="来源地（市）"
        :rules="[{ required: true, message: '请填写来源地' }]"
        @click="showArea = true"
      />
      <van-field
        name="checkboxGroup"
        label="参会日期"
        required
        readonly
        placeholder=""
      >
        <template #input> </template>
      </van-field>
      <van-field name="checkboxGroup">
        <template #input>
          <van-checkbox-group
            v-model="form.joinMeetingDatetime"
            direction="horizontal"
          >
            <van-checkbox
              style="margin-left: 12px"
              name="3月31日"
              shape="square"
              >3月31日</van-checkbox
            >
            <van-checkbox style="margin-left: 12px" name="4月1日" shape="square"
              >4月1日</van-checkbox
            >
            <van-checkbox style="margin-left: 12px" name="4月2日" shape="square"
              >4月2日</van-checkbox
            >
          </van-checkbox-group>
        </template>
      </van-field>

      <van-popup v-model="showArea" position="bottom">
        <van-area
          :columns-num="2"
          :area-list="areaList"
          @confirm="onConfirm"
          @cancel="showArea = false"
        />
      </van-popup>

      <van-field
        name="radio"
        label="交通及住宿"
        required
        :rules="[{ required: true, message: '请选择性别' }]"
      >
        <template #input>
          <van-radio-group v-model="form.jiaotongzhusu" direction="horizontal">
            <van-radio style="margin-right: 10px" :name="1">自理</van-radio>
            <van-radio style="margin-right: 10px" :name="0"
              >会务组协助办理</van-radio
            >
          </van-radio-group>
        </template>
      </van-field>
    </div>
    <div class="button">
      <van-button
        type="info"
        :loading="subLoading"
        loading-text="提交中"
        @click="submitSign"
      >
        确认报名
      </van-button>
      <van-button type="default" @click="showSchedule"> 会议日程 </van-button>
    </div> -->
    <p class="end">报名通道已关闭，感谢您的参与</p>
    <div class="bottom">
      <img :src="bottomImg" alt="" />
    </div>
  </div>
</template>
<script>
import { areaList } from "@vant/area-data";
import { submitForm, getSignTotal } from "../api/api";

export default {
  data() {
    return {
      topImg: require("@/assets/top.png"),
      bottomImg: require("@/assets/bottom.png"),
      areaList,
      showArea: false,
      showPicker: false,
      minDate: new Date(2023, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(Date.now()),
      dateFlag: 1,
      alternate: true,
      form: {
        name: "",
        gender: 0,
        phoneNumber: "",
        identityCard: "",
        enterprise: "",
        job: "",
        source: "",
        joinMeetingDatetime: [],
        // join331: 0,
        // zhusu: 0,
        // signInDatetime: "",
        // signOutDatetime: "",
        jiaotongzhusu: 0,
      },
      subLoading: false,
      needRoom: 0,
    };
  },
  // beforeRouteEnter(to, from, next) {
  //   getSignTotal().then((res) => {
  //     if (res.data >= 5000) {
  //       next("/hb");
  //     } else {
  //       next();
  //     }
  //   });
  // },
  methods: {
    submitAlternateForm() {},
    submitSign() {
      this.subLoading = true;
      if (!this.form.joinMeetingDatetime.length) {
        this.$toast("请将信息填写完整后提交");
        this.subLoading = false;
        return;
      }
      let form = Object.entries(this.form);

      for (let item of form) {
        if (item[0] !== "signInDatetime" && item[0] !== "signOutDatetime") {
          if (!item[1] && item[1] !== 0) {
            this.$toast("请将信息填写完整后提交");
            this.subLoading = false;
            return false;
          }
        }
      }
      console.log(form.zhusu);
      if (this.form.zhusu) {
        if (!this.form.signInDatetime || !this.form.signOutDatetime) {
          this.$toast("请将住宿日期填写完整后提交");
          this.subLoading = false;
          return;
        }
      }
      submitForm(this.form)
        .then((res) => {
          this.subLoading = false;
          this.$router.push({ path: "/success" });
        })
        .catch((err) => {
          this.subLoading = false;
          this.$toast("提交失败，请稍后重试");
        });
    },

    onConfirm(values) {
      this.form.source = values
        .filter((item) => !!item)
        .map((item) => item.name)
        .join("/");
      this.showArea = false;
    },
    dateConfirm(time) {
      let date = new Date(time);
      let y = date.getFullYear();
      let m = date.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      let d = date.getDate();
      d = d < 10 ? "0" + d : d;
      let h = date.getHours();
      h = h < 10 ? "0" + h : h;
      let minute = date.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      switch (this.dateFlag) {
        case 1:
          this.form.signInDatetime = `${y}-${m}-${d}  ${h}:${minute}`;
          break;
        case 2:
          this.form.signOutDatetime = `${y}-${m}-${d}  ${h}:${minute}`;
          break;
        case 3:
          this.form.comeTime = `${y}-${m}-${d}  ${h}:${minute}`;
          break;
        case 4:
          this.form.goTime = `${y}-${m}-${d}  ${h}:${minute}`;
          break;
      }

      this.showPicker = false;
    },
    formatter(type, val) {
      if (type === "year") {
        return val + "年";
      }
      if (type === "month") {
        return val + "月";
      }
      if (type === "day") {
        return val + "日";
      }
      if (type === "hour") {
        return val + "时";
      }
      if (type === "minute") {
        return val + "分";
      }
      return val;
    },
    clearInTime() {
      this.form.signInDatetime = "";
    },
    clearOutTime() {
      this.form.signOutDatetime = "";
    },
    roomChange(n) {
      if (n == 0) {
        this.form.signInDatetime = "";
        this.form.signOutDatetime = "";
      }
    },
    showSchedule() {
      this.$router.push({ path: "/home" });
    },
  },
};
</script>
<style lang="less" scoped>
// .main {
//   width: 100vw;
//   height: 100vh;
//   overflow: scroll;
// }
.header {
  box-sizing: border-box;
  width: 100%;
  //   padding: 0 17px;
  //   margin-top: 20px;
  //   margin-bottom: 30px;
  // background-size: 86px 90px;
  // background: linear-gradient(270deg, #5cf0f1 0%, #00dadb 44%, #0a90d1 100%);
  p {
    margin: 0;
    text-align: center;
    color: rgba(0, 63, 174, 1);
    font-size: 22px;
    line-height: 30px;
    font-weight: 700;
    letter-spacing: 5px;
  }
  img {
    width: 100%;
  }
}
.tip {
  padding: 0 20px;
  margin: 0;
  line-height: 25px;
}
.alternate_header {
  box-sizing: border-box;
  width: 100%;
  padding: 10px 17px;
  p {
    margin: 0;
    text-align: center;
    color: rgba(0, 63, 174, 1);
    font-size: 18px;
    line-height: 30px;
    font-weight: 700;
    letter-spacing: 5px;
  }
}
.tips {
  padding: 0 30px;
  font-size: 12px;
  margin-top: 0;
}
.end {
  margin-top: 100px;
  width: 100vw;
  text-align: center;
  font-size: 22px;
}
.form {
  width: 100%;
  box-sizing: border-box;
  padding: 20px;
  .title {
    font-size: 18px;
    color: #438df0;
    line-height: 30px;
  }
  .form_item {
    p {
      width: 100px;
    }
    padding-left: 30px;
    display: flex;
    align-items: center;
  }
  /depp/ .van-radio--horizontal {
    margin-right: 10px !important;
  }
}
.button {
  width: 100%;
  // margin: 10px 0 -160px 0;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  /deep/ .van-button {
    background-image: linear-gradient(to right, #50b1f8, #3171cf);
  }

  /deep/ .van-button + .van-button {
    margin-left: 30px;
    color: white;
    // background-color: #fff;
    background-image: linear-gradient(to right, #50b1f8, #3171cf);
  }
}
.bottom {
  // width: 100%;
  position: fixed;
  bottom: 0;
  img {
    width: 100%;
  }
}
</style>
